import React from 'react';
import { Row, Col, Alert } from 'reactstrap';
import classes from './Dashboard.module.scss';
import { connect } from 'react-redux';

let newTUW =
  window.location.hostname === 'kontynuacja.tuwpzuw.uspartner.pl' ||
  window.location.hostname === 'localhost';

const Dashboard = (props) =>
  !newTUW ? (
    <React.Fragment>
      <Row>
        <Col xs="12">
          <Alert
            color="warning"
            fade={false}
            style={{
              margin: '0rem 0rem 1rem 0rem',
              textAlign: 'justify'
            }}>
            <strong
              style={{
                fontWeight: '800'
              }}>
              Witamy!
            </strong>
            <br />
            <span
              style={{
                fontWeight: '600'
              }}>
              Jak umówić się na wizytę lekarską lub badanie?
              <br />
              Telefonicznie – 3 całodobowe infolinie czynne 7 dni w tygodniu:{' '}
              <strong>22 505 15 48; 799 698 698; 801 405 905</strong> (opłata
              zgodnie z taryfą operatora)
              <br /> Portal Pacjenta:{' '}
              <a href="https://moje.pzu.pl/cas/login">moje.pzu.pl</a>{' '}
              <small>
                (w przypadku problemów z założeniem konta prosimy dzwonić pod
                numer <b>22 566 50 07</b> - wybierz tonowo 5)
              </small>
              <br />
              Aplikacja mobilna: mojePZU mobile (do pobrania z App Store i
              Google Play)
            </span>
          </Alert>
        </Col>
      </Row>
      <Row>
        <div class={classes.container2}>
          <p className="firstColor">
            <h3>
              Jeśli jesteś zainteresowany ubezpieczeniem Opieki Medycznej w TUW
              PZUW dla byłych pracowników skontaktuj się z nami:
            </h3>
          </p>
          <div class={classes.contact}>
            <h4 className="secondColor">
              Pytania odnośnie ubezpieczenia, wsparcie przy składaniu
              deklaracji, pytania odnośnie płatności
            </h4>
            <br />
            <p>
              <a href="mailto:tuwpzuw@uspartner.pl">tuwpzuw@uspartner.pl</a>
            </p>
            <p>22 417 34 40</p>
            <p>pon. - pt. w godzinach 8:00 – 16:00</p>
          </div>
        </div>
      </Row>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <h5 className="page-header firstColor">
        <b>Grupowe Ubezpieczenie TUW PZUW Opieka Medyczna</b> to profesjonalna{' '}
        <b>opieka medyczna</b>, w renomowanych placówkach medycznych w całej
        Polsce.
      </h5>
      <br />
      <h4 className="firstColor">Jak przystąpić do ubezpieczenia?</h4>
      <ol
        className="mt-3 secondColor"
        style={{ paddingLeft: '0px', listStylePosition: 'inside' }}>
        <li>
          Wydrukuj, a następnie wypełnij i podpisz Oświadczenie o Objęciu
          Ochroną Ubezpieczeniową.{' '}
        </li>
        <li>
          Wyślij wypełnione Oświadczenie w formie skanu lub zdjęcia na adres{' '}
          <a href="mailto:deklaracje@uspartner.pl" style={{ color: '#00B0F0' }}>
            deklaracje@uspartner.pl
          </a>
        </li>
        <li>
          W odpowiedzi otrzymasz <b>indywidualny numer konta</b> do wpłat.
        </li>
        <li>
          Aby zostać objętym ubezpieczeniem zdrowotnym <b>od 1 dnia miesiąca</b>{' '}
          wypełnij Oświadczenie <b>do 10 dnia miesiąca</b> poprzedzającego
          rozpoczęcie ochrony ubezpieczeniowej.{' '}
        </li>
        <li>Opłać miesięczną składkę do 15 dnia każdego miesiąca. </li>
        <li>
          Po opłaceniu składki prześlij oryginał Oświadczenia na adres Datus sp.
          z o.o., ul. Obrzeżna 7, 02-691 Warszawa.
        </li>
      </ol>
      <br />
      <p className="secondColor">
        <b>
          Uwaga: brak opłaty składki w terminie oznacza rezygnację z
          ubezpieczenia bez możliwości ponownego przystąpienia do
          ubezpieczenia.{' '}
        </b>
      </p>
      <br />
      <h4 className="firstColor">Dokumenty do pobrania:</h4>
      <ul
        className="firstColor"
        style={{ paddingLeft: '0px', listStylePosition: 'inside' }}>
        <li>
          <a
            target="_blank"
            href="/public-assets/tuwpzuw/docs/Załącznik nr 5 - oświadczenie ubezpieczonego.pdf">
            <b>Oświadczenie o Objęciu Ochroną Ubezpieczeniową</b>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="/public-assets/tuwpzuw/docs/Opieka Medyczna PZUW_ulotka_kontynuacja.pdf">
            <b>Ulotka informacyjna</b>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="/public-assets/tuwpzuw/docs/Załącznik nr 7 - Zakres Komfort.pdf">
            Zakres ubezpieczenia Komfort Kontynuacja
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="/public-assets/tuwpzuw/docs/Załącznik nr 1 - ogólne warunki ubezpieczenia TUW PZUW Opieka Medyczna.pdf">
            Ogólne Warunki Grupowego Ubezpieczenia TUW PZUW Opieka Medyczna (OM)
          </a>{' '}
        </li>
        <li>
          <a
            target="_blank"
            href="/public-assets/tuwpzuw/docs/Datus_Kontynuacja_wyciąg_zapisów_z_umowy_2026.pdf">
            Wyciąg zapisów z umowy
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="/public-assets/tuwpzuw/docs/lista_placowek_medycznych.xlsx">
            Nasze placówki
          </a>
        </li>
        <li>
          <a target="_blank" href="/public-assets/tuwpzuw/docs/RODO.pdf">
            RODO – Obowiązek Informacyjny
          </a>
        </li>
      </ul>
      <br />
      <h5 className="firstColor">Jeśli masz pytania skontaktuj się z nami:</h5>
      <br />
      <p className="secondColor">
        <b>TUW PZUW – pytania odnośnie ubezpieczenia</b>
      </p>
      <p>
        <a
          href="mailto:ubezpieczeniazdrowotne@tuwpzuw.pl"
          style={{ color: '#00B0F0' }}>
          ubezpieczeniazdrowotne@tuwpzuw.pl
        </a>
      </p>
      <br />
      <p className="secondColor">
        <b>Wsparcie przy składaniu deklaracji, pytania odnośnie płatności</b>
      </p>
      <p>
        <a href="mailto:deklaracje@uspartner.pl" style={{ color: '#00B0F0' }}>
          deklaracje@uspartner.pl
        </a>
      </p>
      <p>22 417 34 40 - infolinia czynna w godzinach 8:00 – 16:00 </p>
      <br />
    </React.Fragment>
  );

const mapStateToProps = (state) => {
  const programs = state.auth.programs || [];
  return {
    isAuthenticated: state.auth.token !== null,

    username: state.auth.user.name,
    tuwpzuw:
      state.auth.user.programId === 'b6f47e72-716e-4e3d-9ce1-797637bf3b69',
    hasPrograms: programs.length > 1 ? true : false,
    menu: state.menu.data && state.menu.data.menu ? state.menu.data.menu : []
  };
};

// const mapDispatchToProps = (dispatch) => {
//     return {
//         logout: () => dispatch(logout())
//     };
// }

export default connect(
  mapStateToProps
  // mapDispatchToProps
)(Dashboard);
